module.exports = __webpack_public_path__ + "media/images/facebook-251ebff62f51d2f8ee4bbc5717d269ee.svg";